import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.sort.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import * as arrays from '../../../base/common/arrays.js';
import { CancellationToken } from '../../../base/common/cancellation.js';
import { EditorAction, registerEditorAction, registerEditorContribution, registerModelCommand } from '../../browser/editorExtensions.js';
import { Position } from '../../common/core/position.js';
import { Range } from '../../common/core/range.js';
import { Selection } from '../../common/core/selection.js';
import { EditorContextKeys } from '../../common/editorContextKeys.js';
import * as modes from '../../common/modes.js';
import * as nls from '../../../nls.js';
import { MenuId } from '../../../platform/actions/common/actions.js';
import { dispose as _dispose } from '../../../base/common/lifecycle.js';
import { WordSelectionRangeProvider } from './wordSelections.js';
import { BracketSelectionRangeProvider } from './bracketSelections.js';
import { CommandsRegistry } from '../../../platform/commands/common/commands.js';
import { onUnexpectedExternalError } from '../../../base/common/errors.js';

var SelectionRanges = /*#__PURE__*/function () {
  function SelectionRanges(index, ranges) {
    _classCallCheck(this, SelectionRanges);

    this.index = index;
    this.ranges = ranges;
  }

  _createClass(SelectionRanges, [{
    key: "mov",
    value: function mov(fwd) {
      var index = this.index + (fwd ? 1 : -1);

      if (index < 0 || index >= this.ranges.length) {
        return this;
      }

      var res = new SelectionRanges(index, this.ranges);

      if (res.ranges[index].equalsRange(this.ranges[this.index])) {
        // next range equals this range, retry with next-next
        return res.mov(fwd);
      }

      return res;
    }
  }]);

  return SelectionRanges;
}();

var SmartSelectController = /*#__PURE__*/function () {
  function SmartSelectController(editor) {
    _classCallCheck(this, SmartSelectController);

    this._ignoreSelection = false;
    this._editor = editor;
  }

  _createClass(SmartSelectController, [{
    key: "dispose",
    value: function dispose() {
      _dispose(this._selectionListener);
    }
  }, {
    key: "run",
    value: function run(forward) {
      var _this = this;

      if (!this._editor.hasModel()) {
        return;
      }

      var selections = this._editor.getSelections();

      var model = this._editor.getModel();

      if (!modes.SelectionRangeRegistry.has(model)) {
        return;
      }

      var promise = Promise.resolve(undefined);

      if (!this._state) {
        promise = provideSelectionRanges(model, selections.map(function (s) {
          return s.getPosition();
        }), CancellationToken.None).then(function (ranges) {
          if (!arrays.isNonEmptyArray(ranges) || ranges.length !== selections.length) {
            // invalid result
            return;
          }

          if (!_this._editor.hasModel() || !arrays.equals(_this._editor.getSelections(), selections, function (a, b) {
            return a.equalsSelection(b);
          })) {
            // invalid editor state
            return;
          }

          var _loop = function _loop(i) {
            ranges[i] = ranges[i].filter(function (range) {
              // filter ranges inside the selection
              return range.containsPosition(selections[i].getStartPosition()) && range.containsPosition(selections[i].getEndPosition());
            }); // prepend current selection

            ranges[i].unshift(selections[i]);
          };

          for (var i = 0; i < ranges.length; i++) {
            _loop(i);
          }

          _this._state = ranges.map(function (ranges) {
            return new SelectionRanges(0, ranges);
          }); // listen to caret move and forget about state

          _dispose(_this._selectionListener);

          _this._selectionListener = _this._editor.onDidChangeCursorPosition(function () {
            if (!_this._ignoreSelection) {
              _dispose(_this._selectionListener);

              _this._state = undefined;
            }
          });
        });
      }

      return promise.then(function () {
        if (!_this._state) {
          // no state
          return;
        }

        _this._state = _this._state.map(function (state) {
          return state.mov(forward);
        });

        var selections = _this._state.map(function (state) {
          return Selection.fromPositions(state.ranges[state.index].getStartPosition(), state.ranges[state.index].getEndPosition());
        });

        _this._ignoreSelection = true;

        try {
          _this._editor.setSelections(selections);
        } finally {
          _this._ignoreSelection = false;
        }
      });
    }
  }], [{
    key: "get",
    value: function get(editor) {
      return editor.getContribution(SmartSelectController.ID);
    }
  }]);

  return SmartSelectController;
}();

SmartSelectController.ID = 'editor.contrib.smartSelectController';

var AbstractSmartSelect = /*#__PURE__*/function (_EditorAction) {
  _inherits(AbstractSmartSelect, _EditorAction);

  var _super = _createSuper(AbstractSmartSelect);

  function AbstractSmartSelect(forward, opts) {
    var _this2;

    _classCallCheck(this, AbstractSmartSelect);

    _this2 = _super.call(this, opts);
    _this2._forward = forward;
    return _this2;
  }

  _createClass(AbstractSmartSelect, [{
    key: "run",
    value: function run(_accessor, editor) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var controller;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                controller = SmartSelectController.get(editor);

                if (!controller) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return controller.run(this._forward);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return AbstractSmartSelect;
}(EditorAction);

var GrowSelectionAction = /*#__PURE__*/function (_AbstractSmartSelect) {
  _inherits(GrowSelectionAction, _AbstractSmartSelect);

  var _super2 = _createSuper(GrowSelectionAction);

  function GrowSelectionAction() {
    _classCallCheck(this, GrowSelectionAction);

    return _super2.call(this, true, {
      id: 'editor.action.smartSelect.expand',
      label: nls.localize('smartSelect.expand', "Expand Selection"),
      alias: 'Expand Selection',
      precondition: undefined,
      kbOpts: {
        kbExpr: EditorContextKeys.editorTextFocus,
        primary: 1024
        /* Shift */
        | 512
        /* Alt */
        | 17
        /* RightArrow */
        ,
        mac: {
          primary: 2048
          /* CtrlCmd */
          | 256
          /* WinCtrl */
          | 1024
          /* Shift */
          | 17
          /* RightArrow */
          ,
          secondary: [256
          /* WinCtrl */
          | 1024
          /* Shift */
          | 17
          /* RightArrow */
          ]
        },
        weight: 100
        /* EditorContrib */

      },
      menuOpts: {
        menuId: MenuId.MenubarSelectionMenu,
        group: '1_basic',
        title: nls.localize({
          key: 'miSmartSelectGrow',
          comment: ['&& denotes a mnemonic']
        }, "&&Expand Selection"),
        order: 2
      }
    });
  }

  return GrowSelectionAction;
}(AbstractSmartSelect); // renamed command id


CommandsRegistry.registerCommandAlias('editor.action.smartSelect.grow', 'editor.action.smartSelect.expand');

var ShrinkSelectionAction = /*#__PURE__*/function (_AbstractSmartSelect2) {
  _inherits(ShrinkSelectionAction, _AbstractSmartSelect2);

  var _super3 = _createSuper(ShrinkSelectionAction);

  function ShrinkSelectionAction() {
    _classCallCheck(this, ShrinkSelectionAction);

    return _super3.call(this, false, {
      id: 'editor.action.smartSelect.shrink',
      label: nls.localize('smartSelect.shrink', "Shrink Selection"),
      alias: 'Shrink Selection',
      precondition: undefined,
      kbOpts: {
        kbExpr: EditorContextKeys.editorTextFocus,
        primary: 1024
        /* Shift */
        | 512
        /* Alt */
        | 15
        /* LeftArrow */
        ,
        mac: {
          primary: 2048
          /* CtrlCmd */
          | 256
          /* WinCtrl */
          | 1024
          /* Shift */
          | 15
          /* LeftArrow */
          ,
          secondary: [256
          /* WinCtrl */
          | 1024
          /* Shift */
          | 15
          /* LeftArrow */
          ]
        },
        weight: 100
        /* EditorContrib */

      },
      menuOpts: {
        menuId: MenuId.MenubarSelectionMenu,
        group: '1_basic',
        title: nls.localize({
          key: 'miSmartSelectShrink',
          comment: ['&& denotes a mnemonic']
        }, "&&Shrink Selection"),
        order: 3
      }
    });
  }

  return ShrinkSelectionAction;
}(AbstractSmartSelect);

registerEditorContribution(SmartSelectController.ID, SmartSelectController);
registerEditorAction(GrowSelectionAction);
registerEditorAction(ShrinkSelectionAction); // word selection

modes.SelectionRangeRegistry.register('*', new WordSelectionRangeProvider());
export function provideSelectionRanges(model, positions, token) {
  var providers = modes.SelectionRangeRegistry.all(model);

  if (providers.length === 1) {
    // add word selection and bracket selection when no provider exists
    providers.unshift(new BracketSelectionRangeProvider());
  }

  var work = [];
  var allRawRanges = [];

  var _iterator = _createForOfIteratorHelper(providers),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var provider = _step.value;
      work.push(Promise.resolve(provider.provideSelectionRanges(model, positions, token)).then(function (allProviderRanges) {
        if (arrays.isNonEmptyArray(allProviderRanges) && allProviderRanges.length === positions.length) {
          for (var i = 0; i < positions.length; i++) {
            if (!allRawRanges[i]) {
              allRawRanges[i] = [];
            }

            var _iterator3 = _createForOfIteratorHelper(allProviderRanges[i]),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var oneProviderRanges = _step3.value;

                if (Range.isIRange(oneProviderRanges.range) && Range.containsPosition(oneProviderRanges.range, positions[i])) {
                  allRawRanges[i].push(Range.lift(oneProviderRanges.range));
                }
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }
        }
      }, onUnexpectedExternalError));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return Promise.all(work).then(function () {
    return allRawRanges.map(function (oneRawRanges) {
      if (oneRawRanges.length === 0) {
        return [];
      } // sort all by start/end position


      oneRawRanges.sort(function (a, b) {
        if (Position.isBefore(a.getStartPosition(), b.getStartPosition())) {
          return 1;
        } else if (Position.isBefore(b.getStartPosition(), a.getStartPosition())) {
          return -1;
        } else if (Position.isBefore(a.getEndPosition(), b.getEndPosition())) {
          return -1;
        } else if (Position.isBefore(b.getEndPosition(), a.getEndPosition())) {
          return 1;
        } else {
          return 0;
        }
      }); // remove ranges that don't contain the former range or that are equal to the
      // former range

      var oneRanges = [];
      var last;

      var _iterator2 = _createForOfIteratorHelper(oneRawRanges),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var range = _step2.value;

          if (!last || Range.containsRange(range, last) && !Range.equalsRange(range, last)) {
            oneRanges.push(range);
            last = range;
          }
        } // add ranges that expand trivia at line starts and ends whenever a range
        // wraps onto the a new line

      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var oneRangesWithTrivia = [oneRanges[0]];

      for (var i = 1; i < oneRanges.length; i++) {
        var prev = oneRanges[i - 1];
        var cur = oneRanges[i];

        if (cur.startLineNumber !== prev.startLineNumber || cur.endLineNumber !== prev.endLineNumber) {
          // add line/block range without leading/failing whitespace
          var rangeNoWhitespace = new Range(prev.startLineNumber, model.getLineFirstNonWhitespaceColumn(prev.startLineNumber), prev.endLineNumber, model.getLineLastNonWhitespaceColumn(prev.endLineNumber));

          if (rangeNoWhitespace.containsRange(prev) && !rangeNoWhitespace.equalsRange(prev) && cur.containsRange(rangeNoWhitespace) && !cur.equalsRange(rangeNoWhitespace)) {
            oneRangesWithTrivia.push(rangeNoWhitespace);
          } // add line/block range


          var rangeFull = new Range(prev.startLineNumber, 1, prev.endLineNumber, model.getLineMaxColumn(prev.endLineNumber));

          if (rangeFull.containsRange(prev) && !rangeFull.equalsRange(rangeNoWhitespace) && cur.containsRange(rangeFull) && !cur.equalsRange(rangeFull)) {
            oneRangesWithTrivia.push(rangeFull);
          }
        }

        oneRangesWithTrivia.push(cur);
      }

      return oneRangesWithTrivia;
    });
  });
}
registerModelCommand('_executeSelectionRangeProvider', function (model) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var positions = args[0];
  return provideSelectionRanges(model, positions, CancellationToken.None);
});